import React, { useState } from 'react'
import PropTypes from 'prop-types'
import SwiperCore, { Autoplay, FreeMode, Thumbs } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/free-mode'
import 'swiper/css/thumbs'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as galleryStyles from './EcmImageGallery.module.scss'

SwiperCore.use([Autoplay, FreeMode, Thumbs])

const EcmImageGallery = ({ images }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null)

  return (
    <div>
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        thumbs={{ swiper: thumbsSwiper }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        className="slides"
      >
        {images.map(
          ({
            image: {
              childImageSharp: { fluid },
            },
            alt,
          }) => (
            <SwiperSlide key={alt}>
              <GatsbyImage image={fluid} alt={alt} loading={'eager'} />
            </SwiperSlide>
          )
        )}
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={4}
        breakpoints={{
          630: { slidesPerView: 8 },
          1270: { slidesPerView: 12 },
          1910: { slidesPerView: 16 },
        }}
        freeMode={true}
        watchSlidesProgress={true}
        className={galleryStyles.thumbs}
        modules={[Thumbs]}
      >
        {images.map(
          ({
            image: {
              childImageSharp: { fixed },
            },
            alt,
          }) => (
            <SwiperSlide key={alt}>
              <GatsbyImage image={fixed} alt={`Thumbnail: ${alt}`} />
            </SwiperSlide>
          )
        )}
      </Swiper>
    </div>
  )
}

EcmImageGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      alt: PropTypes.string,
    })
  ),
}

export default EcmImageGallery
